import { Entity } from '@/store/shared/entity'
export default class ResetPassword extends Entity<number>{
    userName:string;
    name:string;
    userId:number;
    newPassword:string;
    confirmNewPassword:string;
}